const cartAdd = async (e, id) => {
  e.preventDefault();
  const currentElem = e.target;
  currentElem.classList.add('loading');
  const loader = currentElem.querySelector('.loading__spinner');

  const form = currentElem.closest('form')

  // const market_price = form.querySelector('input[name="market_price"]')?.value || 0;
  // const purchase_price = form.querySelector('input[name="purchase_price"]')?.value || 0;
  // const elite_price = form.querySelector('input[name="elite_price"]')?.value || 0;

  if (loader) loader.classList.remove('hidden');

  // console.log('market_price==>', market_price)
  // console.log('purchase_price==>', purchase_price)
  // console.log('elite_price==>', elite_price)
  try {
    const formData = {
      items: [
        {
          id: +id,
          quantity: 1,
          // properties: {
          //   market_price: market_price,
          //   purchase_price: purchase_price,
          //   elite_price: elite_price
          // }
        },
      ],
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, options);
    if (!response.ok) throw new Error('Failed to add item to the cart.');
    const toast = document.querySelector('.js-atc-toast.toast__atc');
    const toast_inner = toast.querySelector('.toast--success')
    if (toast) toast.style.display = 'block';
    if (toast_inner) toast_inner.style.display = 'flex';
  } catch (error) {
    console.error('Error in cartAdd:', error);
  } finally {
    currentElem.classList.remove('loading');
    if (loader) loader.classList.add('hidden');
  }
};
